import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { EmperorButtonModule } from '@boldpenguin/emperor-presentational';
import { getFormId, getPartnerEngineConfig } from '@boldpenguin/sdk';
import { BpSdkStoreService } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.service';
import { applicationFormVisualizerUrl } from 'src/app/shared/utilities/debug-link-utilities';

@Component({
  selector: 'app-application-form-debug-tab',
  templateUrl: './application-form-debug-tab.component.html',
  styleUrls: ['./application-form-debug-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [EmperorButtonModule, MatExpansionModule],
})
export class ApplicationFormDebugTabComponent {
  private readonly sdkStoreService = inject(BpSdkStoreService);

  appFormId = computed(() => {
    const sdkState = this.sdkStoreService.sdkReadyState();
    return sdkState ? getFormId(sdkState) : '';
  });

  formVisualizerUrl = computed(() => {
    const sdkState = this.sdkStoreService.sdkReadyState();
    if (sdkState) {
      const baseUri = getPartnerEngineConfig(sdkState).uri;
      const formId = getFormId(sdkState);
      if (baseUri && formId) {
        return applicationFormVisualizerUrl(baseUri, formId);
      }
    }
    return '';
  });
}
